import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  storage: {
    // 音频文件存储配置
    buckets: {
      audioFiles: 'audio-files'
    }
  }
})

// 导出配置常量
export const SUPABASE_CONFIG = {
  url: supabaseUrl,
  buckets: {
    audioFiles: 'audio-files'
  },
  maxFileSize: parseInt(import.meta.env.VITE_MAX_FILE_SIZE) || 52428800, // 50MB
  allowedFileTypes: [
    // MP3 - 标准和变体类型
    'audio/mpeg',
    'audio/mp3',
    'audio/x-mp3',
    
    // WAV - 标准和变体类型
    'audio/wav',
    'audio/x-wav',
    'audio/wave',
    
    // M4A (Apple Audio) - 标准和变体类型，与Storage桶配置一致
    'audio/m4a',        // Storage桶支持的标准类型
    'audio/x-m4a',      // 浏览器变体，会转换为audio/m4a
    'audio/mp4',        // 另一种变体，会转换为audio/m4a
    'audio/mp4a-latm',  // 另一种变体，会转换为audio/m4a
    
    // AAC - 标准和变体类型
    'audio/aac',
    'audio/x-aac',
    'audio/aacp',
    
    // OGG - 标准和变体类型
    'audio/ogg',
    'audio/x-ogg',
    
    // WebM
    'audio/webm',
    
    // FLAC - 标准和变体类型
    'audio/flac',
    'audio/x-flac'
  ]
}